import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

function TensionesCorrientesChart({ data }) {
    const [activeSeries, setActiveSeries] = useState(null);

    if (!data || data.length === 0) {
        return (
            <div className="flex items-center justify-center h-48 text-gray-500">
                No hay datos históricos disponibles
            </div>
        );
    }

    // Preparar datos para el gráfico
    const chartData = data.map(item => ({
        ...item,
        time: format(new Date(item.timestamp), 'HH:mm:ss'),
        v1: (item.tension_vab || item.tension_l1 || 0) / 1000,
        v2: (item.tension_vbc || item.tension_l2 || 0) / 1000,
        v3: (item.tension_vca || item.tension_l3 || 0) / 1000,
        i1: item.corriente_ia || item.corriente_l1 || 0,
        i2: item.corriente_ib || item.corriente_l2 || 0,
        i3: item.corriente_ic || item.corriente_l3 || 0
    }));

    // Submuestrear si hay demasiados puntos
    const maxPoints = 300;
    let limitedChartData;
    if (chartData.length <= maxPoints) {
        limitedChartData = chartData;
    } else {
        const step = Math.ceil(chartData.length / maxPoints);
        limitedChartData = chartData.filter((_, index) => index % step === 0);
    }

    const handleLegendClick = (e) => {
        setActiveSeries(prev => prev === e.dataKey ? null : e.dataKey);
    };

    const getOpacity = (dataKey) => {
        if (!activeSeries) return 1;
        return activeSeries === dataKey ? 1 : 0.1;
    };

    return (
        <div className="space-y-6">
            {/* Gráfico de Tensiones */}
            <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2 tracking-wider">Histórico de Tensiones (kV)</h4>
                <ResponsiveContainer width="100%" height={200}>
                    <LineChart data={limitedChartData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
                        <XAxis
                            dataKey="time"
                            stroke="#94a3b8"
                            style={{ fontSize: '10px' }}
                            interval="preserveStartEnd"
                            tick={{ fill: '#94a3b8' }}
                        />
                        <YAxis
                            stroke="#94a3b8"
                            style={{ fontSize: '10px' }}
                            domain={[0, 'auto']}
                            tick={{ fill: '#94a3b8' }}
                            label={{ value: 'kV', angle: -90, position: 'insideLeft', style: { fill: '#94a3b8', fontSize: '10px' } }}
                        />
                        <Tooltip
                            contentStyle={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '12px' }}
                        />
                        <Legend onClick={handleLegendClick} wrapperStyle={{ fontSize: '11px', paddingTop: '10px' }} cursor="pointer" />
                        <Line type="monotone" dataKey="v1" stroke="#3b82f6" name="L1 (kV)" dot={false} strokeOpacity={getOpacity('v1')} />
                        <Line type="monotone" dataKey="v2" stroke="#10b981" name="L2 (kV)" dot={false} strokeOpacity={getOpacity('v2')} />
                        <Line type="monotone" dataKey="v3" stroke="#f59e0b" name="L3 (kV)" dot={false} strokeOpacity={getOpacity('v3')} />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            {/* Gráfico de Corrientes */}
            <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2 tracking-wider">Histórico de Corrientes (A)</h4>
                <ResponsiveContainer width="100%" height={200}>
                    <LineChart data={limitedChartData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
                        <XAxis
                            dataKey="time"
                            stroke="#94a3b8"
                            style={{ fontSize: '10px' }}
                            interval="preserveStartEnd"
                            tick={{ fill: '#94a3b8' }}
                        />
                        <YAxis
                            stroke="#94a3b8"
                            style={{ fontSize: '10px' }}
                            domain={[0, 'auto']}
                            tick={{ fill: '#94a3b8' }}
                            label={{ value: 'A', angle: -90, position: 'insideLeft', style: { fill: '#94a3b8', fontSize: '10px' } }}
                        />
                        <Tooltip
                            contentStyle={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '12px' }}
                        />
                        <Legend onClick={handleLegendClick} wrapperStyle={{ fontSize: '11px', paddingTop: '10px' }} cursor="pointer" />
                        <Line type="monotone" dataKey="i1" stroke="#3b82f6" name="L1 (A)" dot={false} strokeOpacity={getOpacity('i1')} />
                        <Line type="monotone" dataKey="i2" stroke="#10b981" name="L2 (A)" dot={false} strokeOpacity={getOpacity('i2')} />
                        <Line type="monotone" dataKey="i3" stroke="#f59e0b" name="L3 (A)" dot={false} strokeOpacity={getOpacity('i3')} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default TensionesCorrientesChart;
